import React from "react";
import "./LMNTheme.scss";
import CloudImageSrcset from "wonderbly-components/lib/CloudImageSrcset";

const LMNTheme = () => (
  <div className="product-hero-decoration" aria-hidden="true">
    <div className="product-hero-decoration--left">
      <CloudImageSrcset
        src="https://images.wonderbly.com/products/lost-my-name/hero-book-pirate-417x621@2x.png"
        width={208}
        className="product-hero-pirate"
      />
      <CloudImageSrcset
        src="https://images.wonderbly.com/products/lost-my-name/hero-book-leaf-196x75@2x.png"
        width={98}
        className="product-hero-leaf product-hero-leaf--1"
      />
      <CloudImageSrcset
        src="https://images.wonderbly.com/products/lost-my-name/hero-book-leaf-196x75@2x.png"
        width={98}
        className="product-hero-leaf product-hero-leaf--2"
      />
    </div>
    <div className="product-hero-decoration--right">
      <CloudImageSrcset
        src="https://images.wonderbly.com/products/lost-my-name/hero-book-cow-346x431@2x.png"
        width={173}
        className="product-hero-cow"
      />
      <CloudImageSrcset
        src="https://images.wonderbly.com/products/lost-my-name/hero-book-leaf-196x75@2x.png"
        width={98}
        className="product-hero-leaf product-hero-leaf--3"
      />
      <CloudImageSrcset
        src="https://images.wonderbly.com/products/lost-my-name/hero-book-leaf-196x75@2x.png"
        width={98}
        className="product-hero-leaf product-hero-leaf--4"
      />
    </div>
    <CloudImageSrcset
      src="https://images.wonderbly.com/products/lost-my-name/hero-earth-410x318@2x.png"
      width={205}
      className="product-hero-earth"
    />
  </div>
);

export default LMNTheme;
